const DEFAULT_SCROLL_OPTIONS = { behavior: "smooth", block: "center", inline: "center" };

export default function scrollAndFocus(element, options = DEFAULT_SCROLL_OPTIONS) {
    if (!(element instanceof HTMLElement)) {
        console.error("ScrollAndFocus: The provided element is not a valid HTMLElement.");
        return;
    }
    element.scrollIntoView(options);
    const focusElement = element.querySelector("a") || element.querySelector("button") || element;
    if (focusElement) {
        focusElement.focus();
    } else {
        console.warn("ScrollAndFocus: No focusable element found. Focusing on the provided element.");
        element.focus();
    }
}